import * as React from "react"
const Potatoes = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}>
    <g clipPath="url(#potatoes)">
      <path
        fill="#C79F63"
        stroke="#010101"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M11.157 8.728c-.467 1.477-2.273 2.964-3.57 3.665-1.348.73-2.685 1.23-3.526 2.47-1.72 2.53-1.309 6.086.939 8.135 7.437 6.78 18-5.219 18-12.83.002-3.085-2.313-5.763-5.298-6.126-3.06-.372-5.617 1.754-6.545 4.686Z"
      />
      <path
        stroke="#010101"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m16 8 .866.5M7.11 15.845l.756.655"
      />
      <circle cx={10} cy={21} r={1} fill="#010101" />
      <circle cx={18} cy={13} r={1} fill="#010101" />
      <circle cx={13} cy={15} r={1} fill="#010101" />
      <path
        fill="#C79F63"
        stroke="#010101"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M20.89 16.394c-1.175.614-3.162.43-4.366.076-1.253-.369-2.36-.868-3.616-.623-2.568.5-4.476 2.903-4.367 5.495.36 8.58 13.982 7.656 18.595 3.043 1.871-1.869 2.102-4.883.529-6.897-1.614-2.065-4.44-2.313-6.775-1.094Z"
      />
      <path
        stroke="#010101"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m12.713 21.223.259-.966M24.24 22.423l.438-.9"
      />
      <circle
        cx={20.561}
        cy={20.965}
        r={1}
        fill="#010101"
        transform="rotate(-105 20.561 20.965)"
      />
      <circle
        cx={16.023}
        cy={23.879}
        r={1}
        fill="#010101"
        transform="rotate(-105 16.023 23.88)"
      />
    </g>
    <defs>
      <clipPath id="potatoes">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default Potatoes
